import { defineComponent, type CSSProperties } from "vue"
import type { ICircleBadgeProps } from "./types"
import { computed } from "vue";
import { tv } from "tailwind-variants";


const clazz = tv({
  base: "flex me-3 shadow-md bg-red-500 rounded-full text-white content-center justify-center items-center",
  variants: {
    color: {
      gray: "bg-gray-500",
      blue: "bg-primary-500"
    }
  }
})

export const CircleBadge = defineComponent<ICircleBadgeProps>((props) => {
  const count = computed(() => props.value ?? 0);
  const text = computed(() => (count.value > 99 ? '99+' : `${count.value}`))

  const style = computed((): CSSProperties => {
    const w = count.value > 99 ? 1.59 : 1.25
    return {
      position: 'absolute',
      top: 0,
      fontSize: count.value > 99 ? '0.63rem' : '0.75rem',
      right: `-${w}rem`,
      width: `${w}rem`,
      height: `${w}rem`,
      fontWeight: count.value > 99 ? 600 : 500,
      zIndex: 101,
      pointerEvents: 'none'
    }
  })

  return () => {
    return (
      <span
        class={clazz({ color: props.variant as any })}
        style={style.value}
      >
        {text.value}
      </span>
    )
  }
}, { props: ['variant', 'value'] });

